export default __webpack_public_path__ + "static/Nerd-9ec516d23944c48d1b6f0b995c63f99c.png";